/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import Restricted from 'src/app/permissions/restricted';
import { useAppDispatch, useAppSelector } from 'src/services/redux/app/store';
import { _changeCompany, companyChange } from 'src/services/redux/slices/auth/auth-slice';
import { isFeedbackHandler } from 'src/app/components/support-feedback/constants';
import { usePendingSupportRequestsCount } from 'src/app/components/support-feedback/service';
import NotificationPreferencesPanel from 'src/app/components/notification-preferences/NotificationPreferencesPanel';
import './styles/styles.css';

type Props = {
  show: boolean;
};

const HeaderUserMenu: FC<Props> = ({ show }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(({ auth }) => auth.user, shallowEqual);
  const isFbHandler = isFeedbackHandler(user?.email);
  const { data: pendingFeedbackCount = 0 } = usePendingSupportRequestsCount(isFbHandler);
  const [prefsOpen, setPrefsOpen] = useState(false);
  const changeCompany = async (branch: any) => {
    dispatch(companyChange({ ...user, company_id: branch?.id, company: branch }));
  };

  return (
    <div
      className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-350px`}
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3 ">
          <div className="symbol symbol-50px me-5">
            <div
              className="symbol-label fs-4 fw-bold bg-primary text-white d-flex align-items-center justify-content-center"
              style={{ width: '50px', height: '50px', borderRadius: '6px' }}
            >
              {user?.name?.charAt(0)?.toUpperCase()}
              {user?.surname?.charAt(0)?.toUpperCase()}
            </div>
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-6  flex-wrap">
              {user?.name} {user?.surname}
              <span className="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">{user?.authorization?.authorization_name}</span>
            </div>
            <span className="text-muted fs-7">{user?.company?.company_name}</span>
          </div>
        </div>
        <a href="#" className=" px-3 fw-bold text-muted text-hover-primary fs-8 text-break">
          {user?.email}
        </a>
      </div>

      <div className="separator my-2"></div>
      {/* Bildirim tercihleri: herkese açık; türler kullanıcının yetkisine göre listelenir */}
      <NotificationPreferencesPanel open={prefsOpen} onToggle={() => setPrefsOpen((v) => !v)} />
      <div className="separator my-2"></div>
      <Restricted to="ROLE_ACCOUNT_SETTINGS">
        <div className="menu-item px-5 my-1 ">
          <Link to="/account/settings" className="menu-link px-5 d-flex align-items-center ">
            Hesap Ayarları
          </Link>
        </div>
      </Restricted>

      <Restricted to="ROLE_CRM_QUOTES">
        <div className="menu-item px-5 my-1 ">
          <Link to="/quotes/settings" className="menu-link px-5 d-flex align-items-center ">
            Teklif Ayarları
          </Link>
        </div>
      </Restricted>

      <Restricted to="ROLE_USERS">
        <div className="menu-item px-5 my-1 ">
          <Link to="/users" className="menu-link px-5 d-flex align-items-center ">
            Kullanıcı İşlemleri
          </Link>
        </div>
      </Restricted>

      <Restricted to="ROLE_ADMIN">
        <div className="menu-item px-5 my-1 ">
          <Link to="/admin" className="menu-link px-5 d-flex align-items-center ">
            <span className="menu-icon me-0">
              <i className="fas fa-cog text-primary fs-6 me-2"></i>
            </span>
            Admin İşlemleri
          </Link>
        </div>
      </Restricted>

      <div className="separator my-2"></div>

      {isFbHandler ? (
        <div className="menu-item px-5 my-1 ">
          <Link to="/support-requests" className="menu-link px-5 d-flex align-items-center justify-content-between border border-primary rounded border-dotted">
            <span className="d-flex align-items-center">
              <i className="bi bi-life-preserver text-primary me-2" />
              Geri Bildirimler
            </span>
            {Number(pendingFeedbackCount) > 0 && (
              <span className="badge badge-danger rounded-pill fw-bold">{Number(pendingFeedbackCount) > 99 ? '99+' : pendingFeedbackCount}</span>
            )}
          </Link>
        </div>
      ) : (
        <Restricted to="ROLE_SUPPORT">
          <div className="menu-item px-5 my-1 ">
            <Link to="/tickets" className="menu-link px-5 d-flex align-items-center border border-primary rounded border-dotted">
              Destek
            </Link>
          </div>
        </Restricted>
      )}

      <Restricted to="ROLE_BRANCHES">
        <div className="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="bottom">
          <div className="menu-link px-5">
            <span className="menu-title">Şubeler</span>
            <span className="menu-arrow"></span>
          </div>

          <div className="menu-sub menu-sub-dropdown py-4">
            {user?.branches?.map((branch: any, idx: number) => (
              <div className="menu-item px-3 " key={idx}>
                <div className={clsx('menu-link px-5 ', { active: branch?.id === user?.company?.id })} onClick={() => changeCompany(branch)}>
                  {branch?.company_name}
                </div>
              </div>
            ))}
            <div className="menu-item px-3 ">
              <Link to="/branches" className={clsx('menu-link px-5')}>
                Tüm Şubeleri Gör
              </Link>
            </div>
          </div>
        </div>
      </Restricted>

      <div className="menu-item px-5">
        <Link to="/logout" className="menu-link px-5  text-danger">
          Çıkış Yap
        </Link>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
